module.exports = __webpack_public_path__ + "img/kv_people.ef44cec5.png";